import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BookingSlotType } from 'src/app/models/booking-slot-type';
import { NgClass, TitleCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { Chip } from 'primeng/chip';

@Component({
  standalone: true,
    selector: 'app-appointment-categories-card',
    templateUrl: './appointment-categories-card.component.html',
    styleUrls: ['./appointment-categories-card.component.scss'],
    imports: [NgClass, TitleCasePipe, TranslatePipe, Button, Chip]
})
export class AppointmentCategoriesCardComponent implements OnInit {

  @Input() isPortletCollapse: boolean = false;
  @Input() arrowDirection: boolean = true;
  @Input() doctorBookingTypes: BookingSlotType[] = [];

  @Output() onNavigateLink = new EventEmitter<any>();
  @Output() onTogglePortlet = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  navigateToLink(url: string)
  {
    this.onNavigateLink.emit(url);
  }

  togglePortlet(key: string)
  {
    this.onTogglePortlet.emit(key);
  }

  isDarkColor(color: string): boolean {
    // Handle empty or invalid colors
    if (!color) return false;
    
    // Remove any leading #
    if (color.startsWith('#')) {
      color = color.substring(1);
    }
    
    // Convert to RGB
    let r, g, b;
    if (color.length === 3) {
      r = parseInt(color.charAt(0) + color.charAt(0), 16);
      g = parseInt(color.charAt(1) + color.charAt(1), 16);
      b = parseInt(color.charAt(2) + color.charAt(2), 16);
    } else if (color.length >= 6) {
      r = parseInt(color.substring(0, 2), 16);
      g = parseInt(color.substring(2, 4), 16);
      b = parseInt(color.substring(4, 6), 16);
    } else {
      return false; // Invalid color format
    }
    
    // Calculate perceived brightness using YIQ formula
    // This is more accurate for human perception than simple RGB average
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    
    // Return true if the color is dark (brightness < 128)
    return brightness < 128;
  }
}
